<template>
  <component
      ref="room"
      :is="ccbotComponent"
      :projectId="projectId"
      :projectTitleName="projectTitleName"
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :noconnectionImageUrl="noconnectionImageUrl"
      :noconnection_icon_refresh="noconnection_icon_refresh"
      :welcomBg="welcomBg"
      :backgroundImage="backgroundImage"
      :isApp="isApp"
      :isMobile="isMobile"
      :device="device"
      :eipToken="eipToken"
      :userId="userId"
      :appModule_conversation_id="appModule_conversation_id"
      :platform_param="platform_param"
      :latData="latData"
      />
</template>

<script>
import Rooms from '@/pages/chatroom/Rooms'
import { EventBus } from '../bus.js'
import { checkFirebase } from '@/pages/js/firebaseHelper.js'
// 狀態記錄為切換登入方法
// import { sessionOver } from '@/api/chat.js'

export default {
  name: "indexRoom",
  components: {
    Rooms
  },
  data() {
    return {
      projectId: 'tickets',
      projectTitleName: '',
      ccbotComponent: '',
      participants: [],
      titleImageUrl: "",
      noconnectionImageUrl: "",
      noconnection_icon_refresh: "",
      welcomBg: "",
      backgroundImage: "",
      isApp: false,
      isMobile: false,
      device: '',
      eipToken: '',
      userId: '',
      customStyle: '',
      iframe_button_url_change_flag: true,
      appModule_conversation_id: '',
      platform_param: '',
      isEipMobileWeb: false,
      moneyUdnCookie: [],
      latData: ''
    };
  },
  created() {

  },
  mounted() {
    if ( this.$route.params.projectId !== undefined) {
      this.projectId = this.$route.params.projectId
    }

    this.isApp = this._isApp()
    // console.log("20191218 " + this.isApp )
    // 從 PC or 手機開啟網頁可判斷，但從 webView 就無法判斷了
    this.isMobile = this._isMobile()
    // console.log("20191218 " + this.isMobile )
    this.device = this.openInDevice()
    // console.log('device : ' + this.device)
    this.platform_param = this._platform_param()
    // console.log('platform_param : ' + this.platform_param)

    if(this.$route.query.conversation_id !== undefined && this.$route.query.conversation_id !== ""){
      this.appModule_conversation_id = this.$route.query.conversation_id
      this.$store.commit('SET_CONVERSATION_ID', this.$route.query.conversation_id)
    }

    // 設定發送狀態，用來決定增加 messageList 時 scroll bar 要移動多少 ------
    sessionStorage.setItem("scrollDown", false)

    try {

      if( this.isApp && typeof(Storage) !=="undefined") {
      // if(typeof(Storage) !=="undefined") {
        // console.log('支援 localStorage')
        if (localStorage.getItem('conversation_list') === null) {
          localStorage.setItem('conversation_list', '{"conversation_list":[]}')
        }

        if (this.appModule_conversation_id !== '') {
          // 有傳入值
          var set_json_conversation_list =
            '{"conversation_list":[{"conversation_id":"' +
            this.appModule_conversation_id +
            '","end_time":' +
            Math.floor(new Date().getTime() / 1000) +'}]}'

          localStorage.setItem('conversation_list', set_json_conversation_list)

          // 設定發送狀態，用來決定增加 messageList 時 scroll bar 要移動多少 ------
          sessionStorage.setItem("scrollDown", true)
          // console.log('user send status : ' + sessionStorage.getItem("scrollDown"))
          // -------------------------------------------------------------------

        } else if (localStorage.getItem('conversation_list') != null
                  && JSON.parse(localStorage.getItem('conversation_list')).conversation_list.length > 0) {
          // console.log(JSON.parse(localStorage.getItem('conversation_list')).conversation_list.length)
          // 沒傳入值，但原本有紀錄 conversation_list
          // 就要判斷時間限制
          // console.log(JSON.parse(localStorage.getItem('conversation_list')).conversation_list[0].end_time )
          // console.log(Math.floor(new Date().getTime() / 1000))
          if (JSON.parse(localStorage.getItem('conversation_list')).conversation_list[0].end_time >
              Math.floor(new Date().getTime() / 1000)) {
            // 時效內
            this.appModule_conversation_id = JSON.parse(
              localStorage.getItem('conversation_list')).conversation_list[0].conversation_id
            this.$store.commit('SET_CONVERSATION_ID', JSON.parse(
              localStorage.getItem('conversation_list')).conversation_list[0].conversation_id)
            // 設定發送狀態，用來決定增加 messageList 時 scroll bar 要移動多少 ------
            sessionStorage.setItem("scrollDown", true)

          } else {
            // 時效外 清除資料
            this.appModule_conversation_id = "",
            this.$store.commit('SET_CONVERSATION_ID', '')
            localStorage.setItem('conversation_list', '{"conversation_list":[]}')
          }
        }
      }

    } catch (error) {
      console.log(error)
      this.appModule_conversation_id = ""
      localStorage.setItem('conversation_list', '{"conversation_list":[]}')
    }

    // 開始吧，呼叫 APP 重新取得 GPS -------------------------------------------
    try {
      if (this.isApp) {
        // 成功
        //將要給原生調用的方法掛載到 window 上面
        window.setGPSLocationData = this.setGPSLocationData
        console.log('20200224 網頁呼叫 APP 取得 GPS')
        if (this.device == 'android') {
          //在js中呼叫 window.AndroidWebView.mobileResetGPSLocationData()，便會觸發此 android 方法。
          window.AndroidWebView.mobileResetGPSLocationData()
        } else {
          window.webkit.messageHandlers.mobileResetGPSLocationData.postMessage()
        }
      }
    } catch (error) {
      console.log(error)
    }

    // 設定發送狀態，用來決定增加 messageList 時 scroll bar 要移動多少 ------
    // sessionStorage.setItem("userSendMessageStatus" , false)
    // console.log('user send status : ' + sessionStorage.getItem("userSendMessageStatus"))
    // -------------------------------------------------------------------
    switch (this.projectId) {
      case 'jinfm':
        this.projectTitleName = '一刻鯨選 '
        this.participants = [
          {
            id: "bot",
            name: "客服機器人",
            imageUrl: "/static/appicon.png"
          },
          {
            id: "human",
            name: "客服人員",
            imageUrl: "/static/membericon_note.png"
          }
        ]
        this.titleImageUrl = "/static/appicon.png"
        this.noconnectionImageUrl = "/static/img_jin_nowifi1.png"
        this.noconnection_icon_refresh = "/static/icon_refresh.png"
        this.welcomBg = "/static/welcomeBg.jpg"
        this.backgroundImage = "/static/background.jpg"
        // this.ccbotComponent = 'ChatRoom'
        //監聽message事件
        window.addEventListener( "message" , this.receiveMessageFromIndex, false );

        break
      case 'eip':
        this.projectTitleName = '聯 8 達 '
        this.participants = [
          {
            id: "bot",
            name: "客服機器人",
            imageUrl: "/static/eip_appicon_online.png"
          },
          {
            id: "human",
            name: "客服人員",
            imageUrl: "/static/membericon_note.png"
          }
        ]
        this.titleImageUrl = "/static/appicon_Eip.png"
        this.noconnectionImageUrl = "/static/img_Eip_nowifi.png"
        this.noconnection_icon_refresh = "/static/icon_refresh_Eip.png"
        this.welcomBg = "/static/welcomeBg_Eip.jpg"
        this.backgroundImage = "/static/background.jpg"
        // this.ccbotComponent = 'EipRoom'

        //回調函數 針對各自專案調整參數 ---------------------------------------------------
        function  receiveMessageFromIndex ( event ) {
          if(event.data.eipToken == undefined) {
            // this.eipToken = ''
            // this.userId = ''
            // this.iframe_button_close_url = ''
            // this.iframe_button_minify_url = ''
          } else {
            this.eipToken = event.data.eipToken
            this.userId = event.data.userId
            this.isEipMobileWeb = event.data.is_eip_mobile_web
            // 將isEipMobileWeb傳至Onboarding
            EventBus.$emit('receive',{
              isEipMobileWeb:this.isEipMobileWeb
            })
          }


          button_close_minify_url_change(event.data.iframe_button_close_url, event.data.iframe_button_minify_url)

          // 20200512 新增版面參數
          if(event.data.platform_param == undefined) {
          } else {
            set_platform_param(event.data.platform_param)
          }
        }

        //監聽message事件
        window.addEventListener( "message" , receiveMessageFromIndex, false );
        break
      case 'utravel':
        // console.log(getProjectId())
        // console.log(this.projectId)
        this.projectTitleName = '有行旅 '
        this.participants = [
          {
            id: "bot",
            name: "客服機器人",
            imageUrl: "/static/appicon_uTravel.png"
          },
          {
            id: "human",
            name: "客服人員",
            imageUrl: "/static/membericon_note.png"
          }
        ]
        this.titleImageUrl= "/static/appicon_uTravel.png"
        this.noconnectionImageUrl= "/static/img_uTravel_nowifi.png"
        this.noconnection_icon_refresh= "/static/icon_refresh_uTravel.png"
        this.welcomBg= "/static/welcomeBg_uTravel.jpg"
        this.backgroundImage = "/static/backgroundUTravel.jpg"
        // this.ccbotComponent = 'uTravelRoom'

        //回調函數 針對各自專案調整參數 ---------------------------------------------------
        function  receiveMessageFromIndex ( event ) {
          if(event.data.eipToken == undefined) {
            // this.eipToken = ''
            // this.userId = ''
            // this.iframe_button_close_url = ''
            // this.iframe_button_minify_url = ''
          } else {
            this.eipToken = event.data.eipToken
            this.userId = event.data.userId
            // this.iframe_button_close_url = event.data.iframe_button_close_url
            // this.iframe_button_minify_url = event.data.iframe_button_minify_url
          }

          // console .log( 'eipToken : ' , this.eipToken )
          // console .log( 'userId : ' , this.userId )

          button_close_minify_url_change(event.data.iframe_button_close_url, event.data.iframe_button_minify_url)

          // 20200512 新增版面參數
          // console.log('event.data.platform_param : ' + event.data.platform_param)
          if(event.data.platform_param == undefined) {
            // this.platform_param = '0'
          } else {
            // this.platform_param = event.data.platform_param
            set_platform_param(event.data.platform_param)
          }

        }
        //監聽message事件
        window.addEventListener( "message" , receiveMessageFromIndex, false );

        break
      case 'udesign':
        this.projectTitleName = 'U Design'
        this.participants = [
          {
            id: "bot",
            name: "客服機器人",
            imageUrl: "/static/appicon_udn.png"
          },
          {
            id: "human",
            name: "客服人員",
            imageUrl: "/static/membericon_note.png"
          }
        ]
        this.titleImageUrl= "/static/appicon_udn.png"
        this.noconnectionImageUrl= "/static/img_uTravel_nowifi.png"
        this.noconnection_icon_refresh= "/static/icon_refresh_uTravel.png"
        this.welcomBg= "/static/welcomeBg_uTravel.jpg"
        this.backgroundImage = "/static/backgroundUTravel.jpg"
        this.noconnectionImageUrl = "/static/img_jin_nowifi1.png"
        this.noconnection_icon_refresh = "/static/icon_refresh.png"
        this.welcomBg= "/static/welcomeBg_uTravel.jpg"
        this.backgroundImage = "/static/background.jpg"

        window.addEventListener( "message" , this.receiveMessageFromIndex, false );

        break
      case 'health':
      this.projectTitleName = '元氣網 '
      this.participants = [
        {
          id: "bot",
          name: "客服機器人",
          imageUrl: "/static/health_bot.png"
        },
        {
          id: "human",
          name: "客服人員",
          imageUrl: "/static/tickets_cs.png"
        }
      ]
      this.titleImageUrl= "/static/health_icon.jpg"
      this.welcomBg= "/static/health_bg_v3.jpg"
      this.backgroundImage = "/static/health_bg_v3.jpg"
      this.noconnectionImageUrl = "/static/img_tickets_nowifi.png"
      window.addEventListener( "message" , this.receiveMessageFromIndex, false );

      break
      case 'tickets':
        this.projectTitleName = 'udn售票網 '
        this.participants = [
          {
            id: "bot",
            name: "客服機器人",
            imageUrl: "/static/health_bot.png"
          },
          {
            id: "human",
            name: "客服人員",
            imageUrl: "/static/tickets_cs.png"
          }
        ]
        this.titleImageUrl= "/static/tickets_icon.jpg"
        this.welcomBg= "/static/tickets_bg.jpg"
        this.backgroundImage = "/static/tickets_bg.jpg"
        this.noconnectionImageUrl = "/static/img_tickets_nowifi.png"
        window.addEventListener( "message" , this.receiveMessageFromIndex, false );

        break
      case 'cs':
        this.projectTitleName = '客服'
        this.participants = [
          {
            id: "bot",
            name: "客服機器人",
            imageUrl: "/static/eip_appicon_online.png"
          },
          {
            id: "human",
            name: "客服人員",
            imageUrl: "/static/membericon_note.png"
          }
        ]
        this.titleImageUrl = "/static/appicon_Eip.png"
        this.noconnectionImageUrl = "/static/img_Eip_nowifi.png"
        this.noconnection_icon_refresh = "/static/icon_refresh_Eip.png"
        this.welcomBg = "/static/welcomeBg_Eip.jpg"
        this.backgroundImage = "/static/background.jpg"

         //回調函數 針對各自專案調整參數 ---------------------------------------------------
        function  receiveMessageFromIndex ( event ) {
          this.eipToken = event.data.eipToken
          this.userId = event.data.userId
          this.isEipMobileWeb = event.data.is_eip_mobile_web
          // 將isEipMobileWeb傳至Onboarding
          EventBus.$emit('receive',{
            isEipMobileWeb:this.isEipMobileWeb
          })

          button_close_minify_url_change(event.data.iframe_button_close_url, event.data.iframe_button_minify_url)

          // 20200512 新增版面參數
          // console.log('event.data.platform_param : ' + event.data.platform_param)
          if(event.data.platform_param == undefined) {
            // this.platform_param = '0'
          } else {
            // this.platform_param = event.data.platform_param
            set_platform_param(event.data.platform_param)
          }

        }
        //監聽message事件
        window.addEventListener( "message" , receiveMessageFromIndex, false );

        break
      case 'udn':
        // 20191121 PM 希望建立一個暫時測試 Rich 的 web 端

        // console.log(getProjectId())
        // console.log(this.projectId)
        this.projectTitleName = 'udn 生活'
        this.participants = [
          {
            id: "bot",
            name: "客服機器人",
            imageUrl: "/static/appicon_udn.png"
          },
          {
            id: "human",
            name: "客服人員",
            imageUrl: "/static/membericon_note.png"
          }
        ]
        this.titleImageUrl= "/static/appicon_udn.png"
        this.noconnectionImageUrl= "/static/img_uTravel_nowifi.png"
        this.noconnection_icon_refresh= "/static/icon_refresh_uTravel.png"
        this.welcomBg= "/static/welcomeBg_uTravel.jpg"
        this.backgroundImage = "/static/backgroundUTravel.jpg"
        // this.ccbotComponent = 'uTravelRoom'

        //回調函數 針對各自專案調整參數 ---------------------------------------------------
        function receiveMessageFromIndex ( event ) {
          if(event.data.eipToken == undefined) {
            // this.eipToken = ''
            // this.userId = ''
            // this.iframe_button_close_url = ''
            // this.iframe_button_minify_url = ''
          } else {
            this.eipToken = event.data.eipToken
            this.userId = event.data.userId
            // this.iframe_button_close_url = event.data.iframe_button_close_url
            // this.iframe_button_minify_url = event.data.iframe_button_minify_url
          }

          // console .log( 'eipToken : ' , this.eipToken )
          // console .log( 'userId : ' , this.userId )

          button_close_minify_url_change(event.data.iframe_button_close_url, event.data.iframe_button_minify_url)

          // 20200512 新增版面參數
          // console.log('event.data.platform_param : ' + event.data.platform_param)
          if(event.data.platform_param == undefined) {
            // this.platform_param = '0'
          } else {
            // this.platform_param = event.data.platform_param
            set_platform_param(event.data.platform_param)
          }

        }
        //監聽message事件
        window.addEventListener( "message" , receiveMessageFromIndex, false );

        break

      case 'vision':
        // console.log(this.projectId)
        this.projectTitleName = '願景工程 '
        this.participants = [
          {
            id: "bot",
            name: "客服機器人",
            imageUrl: "/static/appicon_Eip.png"
          },
          {
            id: "human",
            name: "客服人員",
            imageUrl: "/static/membericon_note.png"
          }
        ]
        this.titleImageUrl= "/static/appicon_Eip.png"
        this.noconnectionImageUrl= "/static/img_uTravel_nowifi.png"
        this.noconnection_icon_refresh= "/static/icon_refresh_uTravel.png"
        this.welcomBg= "/static/welcomeBg_uTravel.jpg"
        this.backgroundImage = "/static/backgroundUTravel.jpg"
        // this.ccbotComponent = 'uTravelRoom'

        //回調函數 針對各自專案調整參數 ---------------------------------------------------
        function receiveMessageFromIndex ( event ) {
          if(event.data.eipToken == undefined) {
            // this.eipToken = ''
            // this.userId = ''
            // this.iframe_button_close_url = ''
            // this.iframe_button_minify_url = ''
          } else {
            this.eipToken = event.data.eipToken
            this.userId = event.data.userId
            // this.iframe_button_close_url = event.data.iframe_button_close_url
            // this.iframe_button_minify_url = event.data.iframe_button_minify_url
          }

          // console .log( 'eipToken : ' , this.eipToken )
          // console .log( 'userId : ' , this.userId )

          button_close_minify_url_change(event.data.iframe_button_close_url, event.data.iframe_button_minify_url)

          // 20200512 新增版面參數
          // console.log('event.data.platform_param : ' + event.data.platform_param)
          if(event.data.platform_param == undefined) {
            // this.platform_param = '0'
          } else {
            // this.platform_param = event.data.platform_param
            set_platform_param(event.data.platform_param)
          }

        }
        //監聽message事件
        window.addEventListener( "message" , receiveMessageFromIndex, false );

        break

      case 'AppRoom':
        // console.log(getProjectId())
        // console.log(this.projectId)
        // this.ccbotComponent = 'AppRoom'
        break
      default :
    }

    // iframe 右上角 關閉 縮小 按鈕 ----------------------------------
    var iframe_button_url_change_flag = true;
    function button_close_minify_url_change(close_url,minify_url) {

      if(iframe_button_url_change_flag && close_url != undefined && minify_url != undefined ){

        iframe_button_url_change_flag = false

        // console .log( 'iframe_button_close_url : ' , close_url )
        // console .log( 'iframe_button_minify_url : ' , minify_url )

        // if(document.all){ // document.createStyleSheet(url)
        //   window.style="body{background-color:blue;";
        //   document.createStyleSheet("javascript:style");
        // }else{ //document.createElement(style)
          var style = document.createElement('style');
          style.type = 'text/css';
          // 關閉按鈕
          // style.innerHTML= style.innerHTML + " .sc-header--close-button div, .sc-header--minify-button div { background-image:url('http://img.ruten.com.tw/s2/d/27/36/21813814532918_258.jpg') !important; }";
          if(close_url != ''){
            style.innerHTML= style.innerHTML + " .sc-header--close-button div { background-image:url('" + close_url +"') !important; }";
          }
          // 縮小按鈕
          if(minify_url != ''){
            style.innerHTML= style.innerHTML + " .sc-header--minify-button div { background-image:url('" + minify_url +"') !important; }";
          }
          document.getElementsByTagName('HEAD').item(0).appendChild(style);
        // }
      }

    }

    // 設定網頁頁籤上的 title 和 圖片
    // (function() {
      var link = document.querySelector("link[rel*='shortcut icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      // link.href = 'http://www.stackoverflow.com/favicon.ico';
      // link.href = "/static/appicon_uTravel.png";
      link.href = this.titleImageUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
      // document.title = this.projectTitleName
      document.title = this.projectTitleName
    // })();

    // 20200512 新增版面參數
    var that = this
    function set_platform_param(data){
      that.platform_param = data
      // console.log('this.platform_param : ' + that.platform_param)
    }
    this.ccbotComponent = 'Rooms'
  },
  methods: {
    setPlatformParam(data) {
      this.platform_param = data
    },
    buttonCloseMinifyUrlChange(closeUrl, minifyUrl) {
      // console.log(closeUrl, minifyUrl, '關閉')

      let flag = true
      if ( flag && closeUrl != undefined && minifyUrl != undefined ){
          flag = false
          const style = document.createElement('style');
          // 關閉按鈕
          if(closeUrl != ''){
            style.innerHTML= style.innerHTML + " .sc-header--close-button div { background-image:url('" + closeUrl +"') !important; }";
          }
          // 縮小按鈕
          if(minifyUrl != ''){
            style.innerHTML= style.innerHTML + " .sc-header--minify-button div { background-image:url('" + minifyUrl +"') !important; }";
          }
          document.getElementsByTagName('HEAD').item(0).appendChild(style);
        }
    },
    async receiveMessageFromIndex(event) {
      if (event.data.firebase_token ) {

        const firebaseToken = event.data.firebase_token
        const idToken =  await checkFirebase(this.$route.params.projectId, firebaseToken)
        // 對接網站登入成功
        if (idToken !== this.$store.getters.firebaseToken) {
          this.$store.commit('SET_FIREBASE_TOKEN', idToken)

          // 狀態記錄為切換登入方法
          // --------
          // const data = {
          //       conversation_id: sessionStorage.getItem("conversation_id"),
          //       user_client_id: sessionStorage.getItem('client_id'),
          //       user_id: sessionStorage.getItem('uid'),
          //       'status': 4
          //     }
          // sessionOver(data, this.$route.params.projectId)
          // --------

          sessionStorage.removeItem('conversation_id')
          this.$refs.room.setInfoMessage('登入成功')

          setTimeout(() => {
            if (this.$store.getters.loginResponse === 'login_call_human') {
              this.$refs.room.tagClicked('轉接專人客服')
            }
            this.$store.commit('SET_LOGIN_RESPONSE', 'default')
          }, 1000)
        } else {
          this.$refs.room.setInfoMessage('登入失敗')
        }
      } else if (event.data.token && event.data.token !== '' && event.data.token !== 'null' ){
        this.$store.commit('SET_C_TOKEN', event.data.token)

      }
      // console.log(this.$store.getters.firebaseToken, firebaseToken)

      // this.buttonCloseMinifyUrlChange(event.data.iframe_button_close_url, event.data.iframe_button_minify_url)

      if(event.data.platform_param == undefined) {
      } else {
        this.setPlatformParam(event.data.platform_param)
      }
    },

    setGPSLocationData(data) {
      this.latData = data
      console.log('20200224 setGPSLocationData 網頁取得APP傳來的 GPS : ' + data)
      this.$store.commit('SET_LOC', data)
      localStorage.setItem('GPSLocationData', data)
    },
    _isApp() {
      // console.log(this.$route.query.app === 'true')
      if(this.$route.query.app === 'true'){
        return true
      }
      return false
    },
    // 判斷是手機還是PC
    _isMobile() {
      // console.log(navigator)
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        // console.log("20190815 測試何處開啟 : " + flag)
        // 從 PC or 手機開啟網頁可判斷，但從 webView 就無法判斷了
        if(flag != null){
          // 手機
          // console.log("20190815 從 PC or 手機 開啟網頁 : " + "手機")
          return true
        } else {
          // PC
          // console.log("20190815 從 PC or 手機 開啟網頁 : " + "pc 端")
          return false
        }

    },
    openInDevice(){
      var u = navigator.userAgent;
      var ua = navigator.userAgent.toLowerCase();
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android終端
      var isiOS = !!u.match(/\(i[^;] ;( U;)? CPU. Mac OS X/); //ios終端
      if(isiOS){
        // console.log("20200117 A iphone 會顯示成 PC 錯誤: iphone")
      } else if (isAndroid) {
        // console.log("20200117 A iphone 會顯示成 PC 錯誤: android")
      } else{
        // console.log("20200117 A iphone 會顯示成 PC 錯誤: PC")
      }

      if (u.match(/android/i)) {
        // console.log("20200117 B 正確: android")
      } else if ( u.match(/(iphone|ipad|ipod);?/i) ) {
        // console.log("20200117 B 正確: iphone|ipad|ipod")
      } else {
        // console.log("20200117 B 正確: PC")
      }

      var device = ''
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        // console.log("20200117 C 正確: iphone" )
        device = "iphone"
      } else if (/(Android)/i.test(navigator.userAgent)) {
        // console.log("20200117 C 正確: android")
        device = "android"
      } else {
        // console.log("20200117 C 正確: PC")
        device = "pc"
      }
      return device
    },
    _platform_param(){
      // console.log('從模組傳進來的 : ' + this.$route.query.platform_param)
      // console.log('從模組傳進來的是 undefined 嗎 ? : ' + (this.$route.query.platform_param === undefined))
      if(this.isApp){
        // APP 用網址帶參數進來
        if(this.$route.query.platform_param === undefined){
          return '0'
        } else {
          return this.$route.query.platform_param + ''
        }
      } else {
        // 網頁用參數進來，點開機器人的事件去處理

      }
      return '0'
    },
    myIP() {
      return new Promise(async (resolve, reject) => {
        const res = await this.axios.get("http://api.hostip.info/get_html.php");
        const data = res.data.split("IP:")[1];
        resolve(data);
      });
    },
    setEdnCookie(val){
      // console.log(val);
      val.forEach(e => {
        console.log(e);
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/IndexRoom.vue